import config from "../../config.json";
import { getEnvironmentVariables, isEmpty } from "../../common/utils";
import { apiCall } from "../../common/http/apiCall";

export const checkUserPermission = async ({
  userId,
  permissionCheckRequestData,
  accessToken,
  refreshToken,
}) => {
  if (isEmpty(userId)) {
    return {
      failed: true,
    };
  }

  let baseUrl = getEnvironmentVariables().REACT_APP_ACCESS_API_URL;
  let url = config.access.checkPermissionUrl.replace("{userId}", userId);

  let data = permissionCheckRequestData;

  var result = await apiCall({
    data,
    baseUrl,
    accessToken: accessToken,
    refreshToken: refreshToken,
    url,
    method: "Post",
  });

  if (result.response?.status === 200) {
    return true;
  }

  if (result.statusCode === 403) {
    return false;
  }

  return {
    failed: true,
  };
};

/**
 * Bulk permission check. Returns the subset of `candidateClaims` that the user
 * actually holds for the given resource scope. Lets callers gate multiple UI
 * controls (e.g. Revoke vs. Delete) with a single backend round-trip.
 */
export const fetchGrantedClaims = async ({
  userId,
  candidateClaims,
  productId,
  appSpaceId,
  organisationId,
  tenantId,
  targetResourceType,
  accessToken,
  refreshToken,
}) => {
  if (isEmpty(userId) || !Array.isArray(candidateClaims) || candidateClaims.length === 0) {
    return [];
  }

  let baseUrl = getEnvironmentVariables().REACT_APP_ACCESS_API_URL;
  let url = config.access.checkPermissionBulkUrl.replace("{userId}", userId);

  let data = {
    userId,
    candidateClaims,
    productId,
    appSpaceId,
    organisationId,
    tenantId,
    targetResourceType,
  };

  let result = await apiCall({
    data,
    baseUrl,
    accessToken,
    refreshToken,
    url,
    method: "Post",
  });

  if (result.response?.status === 200) {
    return result.response.data?.grantedClaims || [];
  }

  return [];
};

export const fetchResourcePermissions = async ({
  tenantId,
  organisationId,
  appSpaceId,
  resourceId,
  resourceType,
  accessToken,
  refreshToken,
}) => {
  let baseUrl = getEnvironmentVariables().REACT_APP_ACCESS_API_URL;
  let url = config.access.fetchResourcePermissions
    .replace("{tenantId}", tenantId)
    .replace("{organisationId}", organisationId)
    .replace("{appSpaceId}", appSpaceId)
    .replace("{resourceType}", resourceType)
    .replace("{resourceId}", resourceId);

  var result = await apiCall({
    baseUrl,
    accessToken,
    refreshToken,
    url,
    method: "Get",
  });

  if (result.response?.status === 200) {
    return result.response.data;
  }

  return {
    failed: true,
  };
};

export const fetchUserTenantRoles = async ({
  userId,
  tenantId,
  accessToken,
  refreshToken,
}) => {
  let baseUrl = getEnvironmentVariables().REACT_APP_ACCESS_API_URL;
  let url = config.access.fetchUserTenantRoles
    .replace("{userId}", userId)
    .replace("{tenantId}", tenantId);

  var result = await apiCall({
    baseUrl,
    accessToken,
    refreshToken,
    url,
    method: "Get",
  });

  if (result.response?.status === 200) {
    return result.response.data;
  }

  return { failed: true };
};
